import { render, staticRenderFns } from "./devices.vue?vue&type=template&id=2a64ad30&scoped=true"
import script from "./devices.vue?vue&type=script&lang=js"
export * from "./devices.vue?vue&type=script&lang=js"
import style0 from "./devices.vue?vue&type=style&index=0&id=2a64ad30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64ad30",
  null
  
)

export default component.exports